import Yup from '~/utils/validations/yup';

export const measurementsFieldsSchemaValidation = Yup.object().shape({
  amount: Yup.number().required('This field is required'),
  measurementUnitId: Yup.string(),
  _id: Yup.string().optional(),
});

export const schemaValidation = Yup.object({
  title: Yup.string().required(),
  description: Yup.string().optional(),
  organizationName: Yup.string().required(),
  causeOptions: Yup.array().min(1).required(),
  isRemote: Yup.boolean().default(false),
  numberOfParticipants: Yup.number()
    .typeError('Enter numbers only')
    .optional()
    .nullable(),
  nameofParticipants: Yup.string().optional(),
  measurementDate: Yup.date().required(),
  measurements: Yup.array().of(measurementsFieldsSchemaValidation),
  location: Yup.object().when('isRemote', {
    is: (isRemote: boolean) => !isRemote,
    then: Yup.object().required('Location is required when not from home'),
    otherwise: Yup.object().optional(),
  }),
});
